import React, {useEffect, useRef, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { HeadlineL, LinkMUpperCase} from '../../styled-components/Font';
import {Logo} from "../../icons/Icons";
import {
    HeaderContainer,
    HeaderLinkActive,
    HeaderRow,
    MobileSeparator
} from "../../styled-components/Header";
import {PrimaryButton} from "../../styled-components/Button";
import Footer from "../Footer";
import {BankLinkA, Separator, Title} from "../../styled-components/Base";
import {
    ContactLinkA,
    ContentWrapper,
    InfoDetailsText,
    InfoTextTitle,
    MainContainer,
    PageWrapper
} from "./Styled";
import {Download} from "../../icons/Components";
import ContactInfo from "../Contact/ContactInfo";
import useOnScreen from "../../hooks/useOnScreen";
import Popup from "../Popup/Popup";
import {AdditionalInfoPageText} from "./text";

export default function AdditionalInfoPage() {
    const navigate = useNavigate();
    const [popupOpened, setPopupOpened] = useState(false)
    const [popupText, setPopupText] = useState('')
    const [menuOpened, setMenuOpened] = useState(false);
    const startCooperation=AdditionalInfoPageText.startCooperation;

    const ref = useRef(null)
    const visible = useOnScreen(ref)
    const [isVisible, setIsVisible] = useState(false)
    useEffect(() => {
        if (visible) setIsVisible(true)
    }, [visible])

    useEffect(() => {
        const closeMenuOnResize = () => {
            if (document.documentElement.clientWidth > 1023) setMenuOpened(false)
        }
        window.addEventListener('resize', closeMenuOnResize)
        return () => window.removeEventListener('resize', closeMenuOnResize)
    },[])


    const handleGoBack = () => {
        navigate('/');
        setTimeout(() => {
            const contactElement = document.querySelector('.about');
            if (contactElement) {
                contactElement.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    const handleStartCooperation = () => {
        navigate('/');
        setTimeout(() => {
            const contactElement = document.querySelector('.contact');
            if (contactElement) {
                contactElement.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <PageWrapper>
            <HeaderContainer className={menuOpened ? "header menu-opened animation2": 'header menu-closed animation2'}>
                <Logo/>
                <HeaderRow style={{width: 'auto'}} className={menuOpened ? "menu-opened-row" : 'menu-closed-row'}>
                    {menuOpened && <MobileSeparator/>}
                    {menuOpened && <HeaderLinkActive
                        onClick={() => {
                            setMenuOpened(false)
                            handleStartCooperation()
                        }}>
                        {startCooperation}
                    </HeaderLinkActive>}
                    <PrimaryButton
                        className={"menu-contact-button"}
                        onClick={handleStartCooperation}>
                        {startCooperation}
                    </PrimaryButton>
                </HeaderRow>
                <LinkMUpperCase className={'menu-switch'}
                                onClick={() => setMenuOpened(!menuOpened)}>
                    {menuOpened
                        ? AdditionalInfoPageText.menuClose
                        : AdditionalInfoPageText.menuOpen}
                </LinkMUpperCase>
            </HeaderContainer>
            <MainContainer ref={ref} className={isVisible ? 'animation2' : ''}>
                <ContactLinkA style={{fontSize:'14px'}} onClick={handleGoBack}>
                    ← {AdditionalInfoPageText.backButton}
                </ContactLinkA>
                <ContentWrapper>
                    <Title>
                        <HeadlineL className={isVisible ? 'animation1' : ''}>
                            {AdditionalInfoPageText.title}
                        </HeadlineL>
                    </Title>

                    <InfoTextTitle>
                        {AdditionalInfoPageText.rightsInfoTitle}
                    </InfoTextTitle>

                    <InfoDetailsText>
                        {AdditionalInfoPageText.rightsInfoText}
                    </InfoDetailsText>

                    <InfoTextTitle>
                        {AdditionalInfoPageText.registryInfoTitle}
                    </InfoTextTitle>

                    <InfoDetailsText>
                        {AdditionalInfoPageText.registryInfoText} {''}
                        <BankLinkA  href="https://reestr.digital.gov.ru/reestr/308803/"
                                    target="_blank"
                        >
                            {AdditionalInfoPageText.registryNumber}
                        </BankLinkA>
                    </InfoDetailsText>

                    <InfoTextTitle>
                        {AdditionalInfoPageText.costTitle}
                    </InfoTextTitle>
                    <InfoDetailsText>
                        {AdditionalInfoPageText.costText1}
                    </InfoDetailsText>
                    <InfoDetailsText>
                        {AdditionalInfoPageText.costText2}
                    </InfoDetailsText>
                    <InfoDetailsText>
                        {AdditionalInfoPageText.costText3}
                    </InfoDetailsText>
                    <InfoDetailsText>
                        {AdditionalInfoPageText.costText4} {''}
                        <BankLinkA  onClick={handleStartCooperation}>{AdditionalInfoPageText.feedbackForm}</BankLinkA>&nbsp;
                        {AdditionalInfoPageText.costText5}
                    </InfoDetailsText>


                    <InfoTextTitle>
                        {AdditionalInfoPageText.techStackTitle}
                    </InfoTextTitle>
                    <InfoDetailsText>— {AdditionalInfoPageText.techPhp}</InfoDetailsText>
                    <InfoDetailsText>— {AdditionalInfoPageText.techGo}</InfoDetailsText>
                    <InfoDetailsText>— {AdditionalInfoPageText.techReact}</InfoDetailsText>
                    <InfoDetailsText>— {AdditionalInfoPageText.techPostgresql}</InfoDetailsText>


                    <InfoTextTitle>
                        {AdditionalInfoPageText.documentationTitle}
                    </InfoTextTitle>
                    <ContactLinkA
                        href="/pdf/descriptionFunctСharacter.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download/> {AdditionalInfoPageText.functionalDescription}
                    </ContactLinkA>
                    <ContactLinkA
                        href="/pdf/deckair_manual.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download/> {AdditionalInfoPageText.userManual}
                    </ContactLinkA>

                    <ContactLinkA
                        href="/pdf/installation.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download/> {AdditionalInfoPageText.installationGuide}
                    </ContactLinkA>
                </ContentWrapper>
             </MainContainer>
            <Separator className={isVisible ? 'animation4' : ''}/>
            <ContactInfo onPopupOpen={()=> setPopupOpened(true)}/>
            <Footer/>
            <Popup
                isPopupOpened={popupOpened}
                onPopupOpen={() => setPopupOpened(true)}
                onPopupClose={() => {
                    setPopupText('')
                    setPopupOpened(false)
                }}
                setPopupText={(value) => setPopupText(value)}
                popupText={popupText}/>
        </PageWrapper>
    );
}
